export default {
    selectedImageEvent(state, image) {
        state.selectedImage = image;
    },
    
    openWindowEvent(state) {
        state.isImageListWindowOpen = true;
    },

    closeWindowEvent(state) {
        state.isImageListWindowOpen = false;
    }
}